import React from 'react';
import { connect } from 'react-redux';

import CopyAndDuplicateButtonSet
  from 'zoomforth_codesbane_editor/component_lib/copy_and_duplicate_button_set.jsx';

import CopiedSubpageNotification
  from 'zoomforth_codesbane_editor/exterior_editor/notifications/copied_subpage_notification.jsx';

import DuplicatedSubpageNotification
  from 'zoomforth_codesbane_editor/exterior_editor/notifications/duplicated_subpage_notification.jsx';

import { 
  ClipboardIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import {
  copySubpage,
  duplicateSubpage
} from 'zoomforth_codesbane_editor/action_creators/subpage.js';

import {
  closeMenuItemEditor
} from 'zoomforth_codesbane_editor/action_creators/navigation.js';

import { success as showNotificationSuccess } from 'zoomforth_app_basics/action_creators/notifications.js';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch, { subpageId }) => {
  return {
    onDuplicateClick: () => {
      dispatch(closeMenuItemEditor());
      dispatch(duplicateSubpage(subpageId));
      dispatch(showNotificationSuccess({
        icon: <ClipboardIcon />,
        children: <DuplicatedSubpageNotification />
      }));
    },
    onCopyClick: () => {
      dispatch(copySubpage(subpageId));
      dispatch(showNotificationSuccess({
        icon: <ClipboardIcon />,
        children: <CopiedSubpageNotification />
      }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CopyAndDuplicateButtonSet);
